export function getAllSections() {
  return Array.from(document.querySelectorAll<HTMLElement>('#___gatsby > div > section'));
}

export function getVisibleSections(sections: HTMLElement[]) {
  return sections.filter((section) => getComputedStyle(section).getPropertyValue('display') !== 'none');
}

export function getVisibleSectionIds(sections: HTMLElement[]) {
  return sections.map((section) => section.id).filter(Boolean);
}

export function getActiveSectionId(sections: HTMLElement[], centerY: number) {
  const firstSection = sections[0];
  const lastSection = sections[sections.length - 1];

  if (
    !sections.length ||
    centerY < firstSection.offsetTop ||
    centerY > lastSection.offsetTop + lastSection.offsetHeight
  ) {
    return null;
  }

  const offsets = sections.map((section) => section.offsetTop + section.offsetHeight);
  const index = bisect(offsets, centerY);
  return sections[index]?.id ?? null;
}

function bisect(a: number[], x: number, lo: number = 0, hi: number = a.length) {
  while (lo < hi) {
    const mid = (lo + hi) >> 1;
    if (x < a[mid]) hi = mid;
    else lo = mid + 1;
  }

  return lo;
}
